// extracted by mini-css-extract-plugin
module.exports = {"container":"_2787e5dfdf--container--n_oDt","icon":"_2787e5dfdf--icon--c6Jh3"};